import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Helmet from "react-helmet";

import Navbar from "./components/Navbar";
import StartPage from "./pages/StartPage";

function App() {
  return (
    <Router>
      <Helmet>
        <title>promAgency.</title>
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta property="og:title" content="promAgency." />
        <meta property="og:site_name" content="promAgency." />
        <meta name="author" content="Hubert Kozik" />
        <meta
          name="description"
          content="Portfolio website made by Hubert Kozik"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <Switch>
        <Route path="/" component={StartPage} />
      </Switch>
    </Router>
  );
}

export default App;
